// extracted by mini-css-extract-plugin
export var aggregationCell = "_2k-p";
export var aggregationRow = "_2k-o";
export var borderlessSpinnerContainer = "_2k-3";
export var cardLayout = "_2k-6";
export var cardLayoutNoFooter = "_2k-a";
export var cardLayoutPageControl = "_2k-9";
export var cardLayoutWithFooter = "_2k-8";
export var closeIcon = "_2k-h";
export var columnHeaderSurface = "_2k-d";
export var columnHeaderSurfaceDragOverlay = "_2k-x";
export var columnHeaderSurfaceResizing = "_2k-u";
export var contextMenuAnchor = "_2k-1";
export var draggableColumnHeader = "_2k-v";
export var draggableColumnHeaderOverlay = "_2k-w";
export var expandIcon = "_2k-i";
export var expanded = "_2k-j";
export var filterDropdown = "_2k-k";
export var filterDropdownDivider = "_2k-f";
export var filterDropdownHeader = "_2k-n";
export var filterDropdownItem = "_2k-m";
export var filterDropdownModal = "_2k-l _2k-k";
export var filterItem = "_2k-e";
export var normalCellWithAdjustableBorder = "_2k-g";
export var pinButtonContainer = "_2k-q";
export var pinIcon = "_2k-r";
export var pinIconActive = "_2k-s";
export var spinner = "_2k-0";
export var spinnerContainer = "_2k-2";
export var tableContainer = "_2k-4";
export var tableContentDraggingColumns = "_2k-c";
export var tableContentInner = "_2k-7";
export var tableContentInnerFill = "_2k-b";
export var tableContentWrapper = "_2k-5";
export var viewButtonContainer = "_2k-t";